import { render, staticRenderFns } from "./DesktopVisits.vue?vue&type=template&id=2221d4c7"
import script from "./DesktopVisits.vue?vue&type=script&lang=js"
export * from "./DesktopVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports